var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductOrbitAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "product-orbit-item-svg",
    width: 286,
    height: 286,
    viewBox: "0 0 286 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "product-orbit-item-1",
    d: "M0,143a143,143 0 1,0 286,0a143,143 0 1,0 -286,0",
    opacity: 0.3,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "product-orbit-item-2",
    d: "M60,143a83,83 0 1,0 166,0a83,83 0 1,0 -166,0",
    opacity: 0.3,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.303,
    cy: 143.002,
    rx: 55.4125,
    ry: 49.6031,
    fill: "url(#paint0_radial_1391_24315)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.042,
    cy: 131.975,
    rx: 10.4561,
    ry: 18.9753,
    fill: "url(#paint1_radial_1391_24315)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.836 142.596H123.988V152.656H113.836V142.596Z",
    fill: "#D6B0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.08 146.62L123.988 152.656L134.141 162.514L145.106 151.65L143.481 135.554H130.08V146.62Z",
    fill: "url(#paint2_linear_1391_24315)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.988 152.656H134.141V162.716H123.988V152.656Z",
    fill: "#D6B0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.898 139.176V148.028L143.481 133.743L153.634 123.281L163.583 133.341L157.898 139.176Z",
    fill: "url(#paint3_linear_1391_24315)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.634 123.281H163.786V133.341H153.634V123.281Z",
    fill: "#D6B0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.394 133.211L134.158 123.537L163.735 152.844L153.971 162.518L124.394 133.211Z",
    fill: "#D6B0FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1391_24315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.808 137.213) rotate(8.02964) scale(32.0402 37.9732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246981,
    stopColor: "#E7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440B81",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1391_24315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.042 131.975) scale(7.83874 18.9753)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440B81",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1391_24315",
    x1: 140.165,
    y1: 171.486,
    x2: 126.058,
    y2: 116.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030979,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1391_24315",
    x1: 140.165,
    y1: 171.486,
    x2: 126.058,
    y2: 116.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.030979,
    stopColor: "#848AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOrbitAdaptive);
export default __webpack_public_path__ + "static/media/ProductOrbitAdaptive.ed0d0098827fded95f4f2326a7154d7b.svg";
export { ForwardRef as ReactComponent };